import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { blue, red, yellow } from "@mui/material/colors";
import EditIcon from '@mui/icons-material/Edit';
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from '@mui/material/InputLabel';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { logout } from "../../src/store/userSilce";
import { useDispatch } from "react-redux";
import { ToastContainer, toast, Zoom } from "react-toastify";


const theme = createTheme({
    palette: {
      primary: {
        main: red[500],
      },
      secondary: {
        main: yellow[500],
      },
      third: {
        main: blue[800],
      },
    },
  });

  const Companys = [
    "ศบพ.",
    "ศฮพ.",
    "ศกอ.",
    "สพร.ทอ.",
    "สคม.ทอ.",
    "สลก.ทอ.",
    "สบ.ทอ.",
    "กพ.ทอ.",
    "ขว.ทอ.",
    "ยก.ทอ.",
    "กบ.ทอ.",
    "กร.ทอ.",
    "ทสส.ทอ.",
    "สปช.ทอ.",
    "กง.ทอ.",
    "จร.ทอ.",
    "สตน.ทอ.",
    "สนภ.ทอ.",
    "สธน.ทอ.",
    "ศซบ.ทอ.",
    "สบน.ทอ.",
    "คปอ.",
    "อย.",
    "รร.การบิน",
    "บน.1",
    "บน.2",
    "บน.3",
    "บน.4",
    "บน.5",
    "บน.7",
    "บน.6",
    "บน.23",
    "บน.21",
    "บน.41",
    "บน.46",
    "บน.56",
    "ศปอว.ทอ.",
    "พธ.ทอ.",
    "ชอ.",
    "สอ.ทอ.",
    "สพ.ทอ.",
    "พอ.",
    "ขส.ทอ.",
    "ชย.ทอ.",
    "ศซว.ทอ.",
    "ยศ.ทอ.",
    "รร.นนก.",
    "ศวอ.ทอ.",
    "สก.ทอ.",
    "สน.ผบ.ดม.",
    "สวบ.ทอ.",
  ];

function ModalEditIpAddress(props) {
    const [alerts, setAlerts] = useState(false);
    const {office , ipaddr} = props;
    const [open, setOpen] = useState(false);
    const [editoffice, setEditoffice] = useState(false);
    // const { user } = useSelector((state) => ({ ...state }));
    const { user } = useSelector((state) => (state.user));
    const token = user.token;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };


    const handleEditOffice = (event) => {
      setEditoffice(event.target.value);
    };

    const handleEditOfficenew = () => {
      var configs = {
        method: "PUT",
        url: process.env.REACT_APP_API_URL + `/EditOffice`,
        headers: {
          authtoken: "bearer " + token,
        },
        data: {
          office: editoffice,
          ipaddr: ipaddr,
        },
      };
      axios(configs)
      .then((res) => {
        // console.log(res.data)
        if (res.data === "ok200") {
          setAlerts(true);
          toast.success("แก้ไขหน่วยงานเรียบร้อย");
          setInterval(() => {
            navigate(0);
          }, 1000);
        } else {
          setAlerts(true);
          toast.error("ไม่สามารถแก้ไขหน่วยงานได้");
        }

        // navigate(0);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        }
        console.log("getPubrelContents: ", err);
      });

    };

  return (
    <>
<ThemeProvider theme={theme}>
      <Link to="#" style={{ textDecoration: "none", color: "black" }}>
    <Button
      variant="contained"
      color="secondary"
      size="small"
      style={{ marginLeft: 16, color: "#000" }}
      startIcon={<EditIcon />}
      onClick={handleClickOpen}
    >
      EDIT
    </Button>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"แก้ไขการอนุญาต IP Address"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           <Box sx={{padding:'10px'}}>

           {/* <FormControl fullWidth>
  <InputLabel id="demo-simple-select-label">หน่วยงาน</InputLabel>
  <Select
    labelId="demo-simple-select-label"
    id="demo-simple-select"
    label="หน่วยงาน"
    onChange={handleEditOffice}
    defaultValue={office}
  >
    {
      Companys.map((Company) => (
        <MenuItem value={Company} key={Company}>{Company}</MenuItem>
      ) )
    }
   
    
  </Select>
</FormControl> */}
           <TextField id="outlined-basic" label="หน่วยงาน" defaultValue={office} variant="outlined" />
           {/* <TextField id="outlined-basic" label="IP Address"  defaultValue={ipaddr} variant="outlined" sx={{marginLeft:'10px'}}/> */}
           </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="third" sx={{color:'#fff'}} variant="contained" onClick={handleEditOfficenew}>บันทึก</Button>
        </DialogActions>
      </Dialog>
    </Link>
  </ThemeProvider>
    </>
  )
}

export default ModalEditIpAddress